import { cond } from 'lodash';

import { getImportError as getEntitiesImportError } from 'store/services/entities/selectors';
import { getImportError as getIntentsImportError } from 'store/services/intents/selectors';
import { getImportError as getRulesImportError } from 'store/services/rules/selectors';
import { getImportError as getContextsImportError } from 'store/services/contexts/selectors';

import {
  partialImportAndMergeEntities,
  partialImportAndReplaceEntities,
} from 'store/services/entities/actions';
import {
  partialImportAndMergeIntents,
  partialImportAndReplaceIntents,
} from 'store/services/intents/actions';
import {
  partialImportAndMergeContexts,
  partialImportAndReplaceContexts,
} from 'store/services/contexts/actions';
import {
  partialImportAndMergeRules,
  partialImportAndReplaceRules,
} from 'store/services/rules/actions';
import { downloadImportedResources } from 'store/shared/actions';

const when = resource => val => val === resource;

export const mapDispatchToProps = resource =>
  cond([
    [
      when('entities'),
      () => ({
        mergeImport: partialImportAndMergeEntities,
        mergeReplace: partialImportAndReplaceEntities,
        downloadImportedResources: downloadImportedResources('entities'),
      }),
    ],
    [
      when('intents'),
      () => ({
        mergeImport: partialImportAndMergeIntents,
        mergeReplace: partialImportAndReplaceIntents,
        downloadImportedResources: downloadImportedResources('intents'),
      }),
    ],
    [
      when('rules'),
      () => ({
        mergeImport: partialImportAndMergeRules,
        mergeReplace: partialImportAndReplaceRules,
        downloadImportedResources: downloadImportedResources('rules'),
      }),
    ],
    [
      when('contexts'),
      () => ({
        mergeImport: partialImportAndMergeContexts,
        mergeReplace: partialImportAndReplaceContexts,
        downloadImportedResources: downloadImportedResources('contexts'),
      }),
    ],
  ])(resource);

export const mapStateToProps = resource => state =>
  cond([
    [
      when('entities'),
      () => ({
        partialImportError: getEntitiesImportError(state),
      }),
    ],
    [
      when('intents'),
      () => ({
        partialImportError: getIntentsImportError(state),
      }),
    ],
    [
      when('rules'),
      () => ({
        partialImportError: getRulesImportError(state),
      }),
    ],
    [
      when('contexts'),
      () => ({
        partialImportError: getContextsImportError(state),
      }),
    ],
  ])(resource);
